export interface Reaction {
  uuid: string;
  reaction: string;
  creator: {
    uuid: string;
    name: string;
  };
  reactionable?: any;
}

export interface GroupedReactions {
  counts: Record<string, number>;
  userReactionUuids: Record<string, Reaction>;
  creators: Record<string, { uuid: string; name: string }[]>;
}

const REACTION_ALIASES: Record<string, string> = {
  thumbs_up: '+1',
};

export const normalizeReactionId = (id: string): string => REACTION_ALIASES[id] ?? id;

export const groupReactions = (
  reactions: Reaction[] = [],
  currentUserId: string
): GroupedReactions => {
  return reactions.reduce(
    (acc, currentReaction) => {
      const reactionType = normalizeReactionId(currentReaction.reaction);

      acc.counts[reactionType] = (acc.counts[reactionType] || 0) + 1;
      acc.creators[reactionType] = acc.creators[reactionType] || [];
      acc.creators[reactionType].push({
        uuid: currentReaction.creator.uuid,
        name: currentReaction.creator.name || 'Unknown User',
      });

      if (currentReaction.creator.uuid === currentUserId) {
        acc.userReactionUuids[reactionType] = currentReaction;
      }

      return acc;
    },
    {
      counts: {} as Record<string, number>,
      userReactionUuids: {} as Record<string, Reaction>,
      creators: {} as Record<string, { uuid: string; name: string }[]>,
    } as GroupedReactions
  );
};
